<template>
  <div class="page-container">
    <div class="settings-form">
      <div class="header-section">
        <h2 class="page-title">TX广告账号管理</h2>


        <div class="license-info">
          <template v-if="hasSmartCardZt">
            <div class="license-item">
              <span class="label">总授权数：</span>
              <span class="value">{{ licenseInfo.total === -1 ? '无限制' : licenseInfo.total }}</span>
            </div>
            <div class="license-item">
              <span class="label">已使用：</span>
              <span class="value">{{ licenseInfo.used }}</span>
            </div>
            <div class="license-item">
              <span class="label">剩余可用：</span>
              <span class="value">{{ licenseInfo.remaining === -1 ? '无限制' : licenseInfo.remaining }}</span>
            </div>
          </template>
          <template v-else>
            <div class="license-item">
              <span class="label">当前模式：</span>
              <span class="value">单主体模式</span>
            </div>
            <div class="license-item">
              <span class="label">总主体数：</span>
              <span class="value">1</span>
            </div>
          </template>
        </div>
      </div>

      <!-- 搜索区域 -->
      <div class="search-bar">
        <el-input v-model="searchForm.ghz_name" placeholder="请输入TX广告名称" clearable size="large"
          style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
          <template #prefix>
            <el-icon>
              <Search />
            </el-icon>
          </template>
        </el-input>

        <el-button type="primary" size="large" @click="handleSearch">
          <el-icon>
            <Search />
          </el-icon>
          搜索
        </el-button>

        <el-button type="success" size="large" @click="openAddDialog" style="float: right">
          <el-icon>
            <Plus />
          </el-icon>
          新增TX广告
        </el-button>

        <el-button type="info" size="large" @click="batchCheckAuthorization" :loading="batchCheckLoading"
          style="margin-left: 15px">
          <el-icon>
            <Refresh />
          </el-icon>
          一键检测RPA授权
        </el-button>

        <el-button type="primary" size="large" @click="openOnlineAuthDialog" class="online-auth-btn">
          <el-icon>
            <Key />
          </el-icon>
          在线授权
        </el-button>
      </div>

      <!-- 账号列表 -->
      <el-table :data="accountList" stripe style="width: 100%; margin-top: 20px" v-loading="loading" row-key="id"
        :row-class-name="getRowClassName">
        <el-table-column prop="ghz_name" label="TX广告名称" width="180" />
        <el-table-column prop="ghz_appid" label="Access_Token" width="200">
          <template #default="{ row }">
            <span v-if="row.ghz_appid">{{ row.ghz_appid }}</span>
            <span v-else class="empty-value">未设置</span>
          </template>
        </el-table-column>
        <el-table-column label="Refresh_Token" width="150">
          <template #default="{ row }">
            <span v-if="row.ghz_secret">******</span>
            <span v-else class="empty-value">未设置</span>
          </template>
        </el-table-column>

        <el-table-column label="RPA授权" width="220">
          <template #default="{ row }">
            <div class="rpa-auth-buttons">
              <!-- 原有授权按钮 -->
              <el-button v-if="!row.cookies || row.cookies === 'null' || row.cookies === '[]'" type="primary"
                size="small" @click="startAuthorization(row)">
                点击授权
              </el-button>
              <el-button v-else type="warning" size="small" @click="startAuthorization(row)">
                重新授权
              </el-button>

              <!-- 新增检测授权按钮 -->
              <el-button :disabled="!row.cookies || row.cookies === 'null' || row.cookies === '[]'" type="success"
                size="small" @click="checkAuthorization(row)" :loading="checkLoading[row.id]">
                检测授权
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="IP+端口" width="150">
          <template #default="{ row }">
            <span v-if="row.ip_port">{{ row.ip_port }}</span>
            <span v-else class="empty-value">未设置</span>
          </template>
        </el-table-column>
        <el-table-column label="账号密码" width="180">
          <template #default="{ row }">
            <span v-if="row.ip_password" class="password-preview">
              {{ row.ip_password }}
            </span>
            <span v-else class="empty-value">未设置</span>
          </template>
        </el-table-column>
        <el-table-column prop="notes" label="备注" width="150" />
        <el-table-column prop="create_time" label="创建时间" width="180" />
        <el-table-column prop="update_time" label="更新时间" width="180" />

        <!-- 独立指纹列 -->
        <el-table-column label="独立指纹" width="100" fixed="right">
          <template #default="{ row }">
            <div class="fingerprint-status">
              <el-tooltip effect="light" placement="left" popper-class="fingerprint-tooltip"
                :disabled="!row.fingerprint || row.fingerprint === 'null' || row.fingerprint === '[]'">
                <template #content>
                  <div v-if="row.fingerprint && row.fingerprint !== 'null' && row.fingerprint !== '[]'">
                    <div class="fingerprint-detail">
                      <h4>浏览器指纹详情</h4>
                      <div class="fingerprint-item" v-for="(value, key) in parseFingerprint(row.fingerprint)"
                        :key="key">
                        <span class="fingerprint-label">{{ formatLabel(key) }}:</span>
                        <span class="fingerprint-value">{{ value }}</span>
                      </div>
                    </div>
                  </div>
                </template>

                <el-icon v-if="row.fingerprint && row.fingerprint !== 'null' && row.fingerprint !== '[]'"
                  color="#67C23A" :size="20" class="success-icon">
                  <Check />
                </el-icon>
                <el-icon v-else color="#F56C6C" :size="20" class="error-icon">
                  <Close />
                </el-icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template #default="scope">
            <el-button type="primary" size="small" @click="openEditDialog(scope.row)">
              <el-icon>
                <Edit />
              </el-icon>
              编辑
            </el-button>
            <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
              <el-icon>
                <Delete />
              </el-icon>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
          :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
          @size-change="fetchAccountList" @current-change="fetchAccountList" />
      </div>
    </div>


    <!-- 新增：在线授权对话框 -->
    <el-dialog v-model="onlineAuthDialogVisible" title="TX广告在线授权" width="680px" class="online-auth-dialog-wrapper">
      <div class="online-auth-dialog">
        <!-- 授权方式选择 -->
        <div class="auth-type-section">
          <h3 class="section-title">选择授权方式</h3>
          <div class="auth-type-buttons">
            <el-radio-group v-model="authType">
              <el-radio label="ACCOUNT_TYPE_WECHAT" size="large">
                <div class="auth-type-item wechat-item">
                  <div class="auth-icon-wrapper">
                    <div class="auth-icon wechat-icon">💬</div>
                    <div class="selected-indicator">
                      <el-icon>
                        <Check />
                      </el-icon>
                    </div>
                  </div>
                  <div class="auth-text">
                    <div class="auth-title">微信登录</div>
                    <div class="auth-desc">推荐使用，授权流程更快捷</div>
                    <div class="auth-features">
                      <span class="feature-tag">快速</span>
                      <span class="feature-tag">安全</span>
                      <span class="feature-tag">稳定</span>
                    </div>
                  </div>
                </div>
              </el-radio>
              <el-radio label="ACCOUNT_TYPE_QQ" size="large">
                <div class="auth-type-item qq-item">
                  <div class="auth-icon-wrapper">
                    <div class="auth-icon qq-icon">🐧</div>
                    <div class="selected-indicator">
                      <el-icon>
                        <Check />
                      </el-icon>
                    </div>
                  </div>
                  <div class="auth-text">
                    <div class="auth-title">QQ登录</div>
                    <div class="auth-desc">使用QQ账号进行授权</div>
                    <div class="auth-features">
                      <span class="feature-tag">兼容</span>
                      <span class="feature-tag">通用</span>
                    </div>
                  </div>
                </div>
              </el-radio>
            </el-radio-group>
          </div>
        </div>

        <!-- 授权流程 -->
        <div class="auth-process-section">
          <h3 class="section-title">授权流程</h3>
          <div class="process-steps">
            <div class="process-step">
              <div class="step-number">1</div>
              <div class="step-content">
                <div class="step-title">选择授权方式</div>
                <div class="step-desc">选择微信或QQ登录</div>
              </div>
            </div>
            <div class="step-arrow">→</div>
            <div class="process-step">
              <div class="step-number">2</div>
              <div class="step-content">
                <div class="step-title">扫码登录</div>
                <div class="step-desc">在新窗口完成扫码授权</div>
              </div>
            </div>
            <div class="step-arrow">→</div>
            <div class="process-step">
              <div class="step-number">3</div>
              <div class="step-content">
                <div class="step-title">自动完成</div>
                <div class="step-desc">系统自动保存账号信息</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 温馨提示 -->
        <div class="tips-section">
          <div class="tips-header">
            <el-icon class="tips-icon">
              <InfoFilled />
            </el-icon>
            <span>温馨提示</span>
          </div>
          <div class="tips-content">
            <p>• 授权过程安全加密，不会保存您的账号密码</p>
            <p>• 建议使用微信授权，流程更快捷稳定</p>
            <p>• 授权成功后系统将自动创建广告账号</p>
            <p>• 可随时在腾讯广告平台撤销授权</p>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="onlineAuthDialogVisible = false" size="large" class="cancel-btn">
            取消授权
          </el-button>
          <el-button type="primary" @click="startOnlineAuth" :loading="authLoading" size="large" class="confirm-btn">
            <template #loading>
              <el-icon class="is-loading">
                <Loading />
              </el-icon>
              授权中...
            </template>
            <template #default>
              <el-icon>
                <Key />
              </el-icon>
              开始授权
            </template>
          </el-button>
        </div>
      </template>
    </el-dialog>

    <!-- QR Code Dialog -->
    <el-dialog v-model="qrDialogVisible" title="TX广告授权" width="400px">
      <div class="qr-code-container">
        <div v-if="qrLoading" class="loading-container">
          <el-icon class="is-loading" size="30">
            <Loading />
          </el-icon>
          <span>正在获取二维码...</span>
        </div>
        <img v-else :src="qrCodeBase64" alt="TX广告授权二维码" class="qr-code-image" />
        <div class="qr-instructions">
          <p>请使用微信扫描上方二维码授权TX广告</p>
          <p>扫描成功后点击下方确认按钮完成授权</p>
        </div>
      </div>

      <template #footer>
        <el-button @click="qrDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAuthorization" :loading="confirmLoading" :disabled="!qrCodeBase64">
          确认授权
        </el-button>
      </template>
    </el-dialog>

    <!-- 新增/编辑对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="600px" :close-on-click-modal="false">
      <el-form ref="accountForm" :model="accountForm" label-width="120px" :rules="formRules">
        <el-form-item label="广告名称" prop="ghz_name">
          <el-input v-model="accountForm.ghz_name" placeholder="请输入TX广告名称" size="large" />
        </el-form-item>

        <el-form-item label="Access_Token" prop="ghz_appid">
          <el-input v-model="accountForm.ghz_appid" placeholder="请输入TX广告Access_Token" size="large" />
        </el-form-item>

        <el-form-item label="Refresh_Token" prop="ghz_secret">
          <el-input v-model="accountForm.ghz_secret" placeholder="请输入TX广告Refresh_Token" size="large" show-password />
        </el-form-item>

        <el-form-item label="IP+端口">
          <el-input v-model="accountForm.ip_port" placeholder="格式：232.33.1.1:16817（可选）" size="large" />
          <div class="form-tip">非必填项，可留空</div>
        </el-form-item>

        <el-form-item label="账号密码">
          <el-input v-model="accountForm.ip_password" placeholder="格式：账号:密码，如：34123:55332（可选）" size="large"
            show-password />
          <div class="form-tip">非必填项，可留空</div>
        </el-form-item>

        <el-form-item label="备注信息">
          <el-input v-model="accountForm.notes" placeholder="请输入备注信息" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAccountForm">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import Cookies from 'js-cookie';
import {
  Search, Plus, Edit, Delete, Loading, Refresh, Check, Close, Key
} from '@element-plus/icons-vue'

export default {
  name: 'AccountManagement',
  components: { Search, Plus, Edit, Delete, Loading, Refresh, Check, Close, Key },
  data() {
    // IP端口格式验证（非必填）
    const validateIpPort = (rule, value, callback) => {
      if (value && !/^(\d{1,3}\.){3}\d{1,3}:\d{1,5}$/.test(value)) {
        callback(new Error('格式错误，示例：192.168.1.1:8080'));
      } else {
        callback();
      }
    };

    // 账号密码格式验证（非必填）
    const validateAccountPassword = (rule, value, callback) => {
      if (value && !/^[^:]+:[^:]+$/.test(value)) {
        callback(new Error('格式错误，示例：username:password'));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      checkLoading: {}, // 单个检测加载状态
      batchCheckLoading: false, // 批量检测加载状态
      dialogVisible: false,
      dialogTitle: '新增TX广告',
      isEditMode: false,
      qrDialogVisible: false,
      qrLoading: false,
      confirmLoading: false,
      qrCodeBase64: '',
      currentAuthRow: null,
      // 在线授权相关数据
      onlineAuthDialogVisible: false,
      authType: 'ACCOUNT_TYPE_WECHAT',
      authLoading: false,
      searchForm: {
        ghz_name: ''
      },
      accountForm: {
        id: null,
        ghz_name: '',
        ip_port: '',
        ip_password: '',
        ghz_appid: '',
        ghz_secret: '',
        notes: ''
      },
      formRules: {
        ghz_name: [
          { required: true, message: '请输入TX广告名称', trigger: 'blur' }
        ],
        ghz_appid: [
          { required: true, message: '请输入TX广告AppID', trigger: 'blur' }
        ],
        ghz_secret: [
          { required: true, message: '请输入TX广告Secret', trigger: 'blur' }
        ],
        ip_port: [
          { validator: validateIpPort, trigger: 'blur' }
        ],
        ip_password: [
          { validator: validateAccountPassword, trigger: 'blur' }
        ],
      },
      accountList: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      hasSmartCardZt: false, // 新增字段
      licenseInfo: {
        total: 0,
        used: 0,
        remaining: 0
      }
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('user_info') || '{}')
    }
  },
  mounted() {
    this.fetchAccountList();
    this.fetchLicenseInfo();
    this.checkSmartCardZt(); // 新增调用
    // 监听来自授权窗口的消息
    this.setupMessageListener();

  },


  methods: {
    // 设置表格行的class
    getRowClassName({ row }) {
      return `account-row-${row.id}`;
    },
    // 设置消息监听
    setupMessageListener() {
      window.addEventListener('message', (event) => {
        // 验证消息来源
        if (event.origin !== 'https://hd.aijzdi.com') {
          return;
        }

        const message = event.data;

        if (message.type === 'OAUTH_SUCCESS') {
          // 收到授权成功消息，刷新页面
          this.$message.success('授权成功，正在刷新页面...');

          // 延迟1秒后刷新，确保用户看到消息
          setTimeout(() => {
            this.fetchAccountList();
          }, 1000);
        }
      });
    },
    // 解析指纹数据
    parseFingerprint(fingerprint) {
      try {
        if (typeof fingerprint === 'string') {
          return JSON.parse(fingerprint);
        }
        return fingerprint;
      } catch (e) {
        console.error('解析指纹数据失败:', e);
        return {};
      }
    },


    // 打开在线授权对话框
    openOnlineAuthDialog() {
      this.onlineAuthDialogVisible = true;
      this.authType = 'ACCOUNT_TYPE_WECHAT';
      this.authLoading = false;
    },

    // 开始在线授权
    async startOnlineAuth() {
      this.authLoading = true;

      try {
        // 记录授权开始前的账号数量
        const initialAccountCount = this.accountList.length;

        // 构建授权参数
        const authParams = {
          store_id: this.userInfo.id,
          base_url: config.BASE_URL,
          user_id: 1,
          auth_type: this.authType,
          timestamp: Date.now(),
          initial_count: initialAccountCount // 记录开始时的账号数量
        };

        // 编码state参数
        const state = encodeURIComponent(JSON.stringify(authParams));

        // 构建授权URL
        const authUrl = `https://hd.aijzdi.com/?state=${state}`;

        // 打开新窗口进行授权
        const authWindow = window.open(authUrl, 'tencent_oauth', 'width=800,height=700');

        if (!authWindow) {
          this.$message.error('请允许弹出窗口以进行授权');
          return;
        }

        // 监听窗口关闭，检查授权结果（传递初始数量）
        this.checkAuthCompletion(initialAccountCount);

        this.onlineAuthDialogVisible = false;
        this.$message.success('已打开授权页面，请在新窗口中完成授权');

      } catch (error) {
        console.error('启动授权失败:', error);
        this.$message.error('启动授权失败');
      } finally {
        this.authLoading = false;
      }
    },


    // 检查授权完成状态
    async checkAuthCompletion(initialCount) {
      let checkCount = 0;
      const maxCheckCount = 60;

      const checkInterval = setInterval(async () => {
        try {
          checkCount++;

          // 调用后端接口检查授权状态，传递初始数量
          const authStatus = await this.checkAuthStatusFromBackend(initialCount);

          if (authStatus.status === 'completed') {
            clearInterval(checkInterval);
            this.handleAuthSuccess(authStatus);
            return;

          } else if (authStatus.status === 'failed') {
            clearInterval(checkInterval);
            this.$message.error(`授权失败: ${authStatus.message}`);
            return;

          } else if (authStatus.status === 'pending') {
            console.log(`授权进行中... (${checkCount}/${maxCheckCount})`);
          }

          if (checkCount >= maxCheckCount) {
            clearInterval(checkInterval);
            this.$message.warning('授权检测超时，请检查授权状态');
          }

        } catch (error) {
          console.error('检查授权状态失败:', error);
          if (checkCount >= 10) {
            clearInterval(checkInterval);
            this.$message.error('授权状态检查异常');
          }
        }
      }, 3000);

      setTimeout(() => {
        clearInterval(checkInterval);
      }, 600000);
    },



    // 从后端检查授权状态
    async checkAuthStatusFromBackend(initialCount) {
      try {
        const response = await axios.post(
          `${config.BASE_URL}/shop/api/gzh_auth_management.php`,
          {
            action: 'check_oauth_status',
            store_id: this.userInfo.id,
            initial_count: initialCount // 传递初始数量
          }
        );

        console.log('授权状态检查结果:', response.data);
        return response.data;
      } catch (error) {
        console.error('检查授权状态失败:', error);
        return { status: 'error', message: '检查失败' };
      }
    },

    // 处理授权成功
    handleAuthSuccess(authStatus) {
      let successMessage = '授权成功！';

      if (authStatus.new_accounts && authStatus.new_accounts.length > 0) {
        // 有新账号创建
        const accountNames = authStatus.new_accounts.map(acc => acc.ghz_name).join('、');
        successMessage = `授权成功！新账号「${accountNames}」已创建`;

      } else if (authStatus.updated_accounts && authStatus.updated_accounts.length > 0) {
        // 有账号更新
        const accountNames = authStatus.updated_accounts.map(acc => acc.ghz_name).join('、');
        successMessage = `授权成功！账号「${accountNames}」已更新`;
      }

      // 显示成功消息
      this.$message.success(successMessage);

      // 延迟1秒后刷新页面，让用户看到成功消息
      setTimeout(() => {
        this.fetchAccountList(); // 刷新数据

        // 可选：如果授权窗口还在，自动关闭
        this.tryCloseAuthWindow();

      }, 1000);
    },
    // 尝试关闭授权窗口
    tryCloseAuthWindow() {
      // 检查是否有打开的授权窗口并尝试关闭
      if (window.opener && !window.opener.closed) {
        try {
          window.opener.focus(); // 让原窗口获得焦点
        } catch (e) {
          // 跨域限制，忽略错误
        }
      }

      // 刷新完成后显示提示
      this.$nextTick(() => {
        this.$notify({
          title: '授权完成',
          message: '账号列表已自动刷新',
          type: 'success',
          duration: 3000
        });
      });
    },
    // 高亮显示指定账号
    highlightAccounts(accountIds) {
      this.$nextTick(() => {
        accountIds.forEach(accountId => {
          // 使用class选择器
          const rowElement = document.querySelector(`.account-row-${accountId}`);
          if (rowElement) {
            rowElement.classList.add('newly-authorized');

            // 5秒后移除高亮
            setTimeout(() => {
              rowElement.classList.remove('newly-authorized');
            }, 5000);
          }
        });

        this.$message.info(`已找到 ${accountIds.length} 个授权账号`);
      });
    },

    // 新增方法：检查 smart_card_zt 状态
    async checkSmartCardZt() {
      try {
        const response = await axios.post(
          `${config.BASE_URL}/shop/api/gzh_auth_management.php`,
          {
            action: 'check_smart_card_zt',
            store_id: this.userInfo.id
          }
        );

        if (response.data.success) {
          this.hasSmartCardZt = response.data.has_smart_card_zt;
        }
      } catch (error) {
        console.error('检查 smart_card_zt 状态失败:', error);
        // 默认设置为 false
        this.hasSmartCardZt = false;
      }
    },

    // 格式化标签显示
    formatLabel(key) {
      const labelMap = {
        'user_agent': '用户代理',
        'screen_resolution': '屏幕分辨率',
        'language': '语言',
        'webgl_vendor': 'WebGL供应商',
        'renderer': '渲染器',
        'timezone': '时区',
        'hardware_concurrency': '硬件并发数',
        'device_memory': '设备内存',
        'platform': '平台',
        'do_not_track': '禁止追踪'
      };

      return labelMap[key] || key;
    },

    // 修改 checkAuthorization 方法
    async checkAuthorization(row) {
      this.checkLoading = { ...this.checkLoading, [row.id]: true };

      try {
        const response = await axios.post(
          `${config.BASE_URL}/shop/api/update_cookies_by_ids.php`,
          {
            ids: [row.id]
          }
        );

        if (response.data.success) {
          const result = response.data.results.find(r => r.id === row.id);
          if (result) {
            if (result.status === 'success') {
              this.$message.success(`ID ${row.id} 授权有效，已更新cookies`);
            } else if (result.status === 'cooldown') {
              this.$message.warning(`ID ${row.id} 处于冷却期，${result.next_available}后可更新`);
            } else {
              this.$message.warning(`ID ${row.id} ${result.message}`);
            }
          }
        } else {
          this.$message.error(response.data.error || '检测授权失败');
        }
      } catch (error) {
        let errorMsg = '检测授权失败';
        if (error.response && error.response.data && error.response.data.error) {
          errorMsg = error.response.data.error;
        }
        this.$message.error(errorMsg);
        console.error('检测授权错误:', error);
      } finally {
        this.checkLoading = { ...this.checkLoading, [row.id]: false };
        this.fetchAccountList(); // 刷新列表
      }
    },

    // 批量检测授权
    async batchCheckAuthorization() {
      const validIds = this.accountList
        .filter(item => item.cookies && item.cookies !== 'null' && item.cookies !== '[]')
        .map(item => item.id);

      if (validIds.length === 0) {
        this.$message.warning('没有可检测的授权账号');
        return;
      }

      this.$confirm(`确定要检测${validIds.length}个账号的授权状态吗？`, '批量检测', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
        this.batchCheckLoading = true;

        try {
          const response = await axios.post(
            `${config.BASE_URL}/shop/api/update_cookies_by_ids.php`,
            {
              ids: validIds
            }
          );

          if (response.data.success) {
            const stats = {
              success: 0,
              cooldown: 0,
              error: 0
            };

            response.data.results.forEach(result => {
              if (result.status === 'success') stats.success++;
              else if (result.status === 'cooldown') stats.cooldown++;
              else stats.error++;
            });

            this.$notify({
              title: '批量检测完成',
              message: `成功: ${stats.success}个, 冷却中: ${stats.cooldown}个, 失败: ${stats.error}个`,
              type: 'success',
              duration: 5000
            });
          } else {
            this.$message.error(response.data.error || '批量检测失败');
          }
        } catch (error) {
          let errorMsg = '批量检测失败';
          if (error.response && error.response.data && error.response.data.error) {
            errorMsg = error.response.data.error;
          }
          this.$message.error(errorMsg);
          console.error('批量检测错误:', error);
        } finally {
          this.batchCheckLoading = false;
          this.fetchAccountList(); // 刷新列表
        }
      }).catch(() => {
        // 用户取消
      });
    },

    // 开始授权流程
    async startAuthorization(row) {
      this.currentAuthRow = row;
      this.qrDialogVisible = true;
      this.qrLoading = true;
      this.qrCodeBase64 = '';

      try {
        const response = await axios.post(
          `${config.BASE_URL}/shop/api/gzh_auth_cookies.php`,
          {
            action: 'get_qr',
            id: this.currentAuthRow.id,
            store_id: this.userInfo.id
          }
        );

        if (response.data.status === 'success') {
          this.qrCodeBase64 = response.data.base64;
          this.webId = response.data.web_id;
          this.fingerprint = response.data.fingerprint;
        } else {
          this.$message.error(response.data.error || '获取二维码失败');
        }
      } catch (error) {
        let errorMsg = '获取二维码失败';
        if (error.response && error.response.data && error.response.data.error) {
          errorMsg = error.response.data.error;
        }
        this.$message.error(errorMsg);
        console.error('获取二维码错误:', error);
      } finally {
        this.qrLoading = false;
      }
    },

    // 确认授权
    confirmAuthorization() {
      this.$confirm('确认已完成扫码授权吗？', '确认授权', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.confirmLoading = true;

        try {
          const response = await axios.post(
            `${config.BASE_URL}/shop/api/gzh_auth_cookies.php`,
            {
              action: 'update_cookies',
              web_id: this.webId,
              fingerprint: this.fingerprint,
              id: this.currentAuthRow.id,
              store_id: this.userInfo.id
            }
          );

          if (response.data.status === 'success') {
            this.$message.success('授权成功');
            this.qrDialogVisible = false;
            this.fetchAccountList(); // 刷新列表
          } else {
            let errorMsg = response.data.error || '授权失败';
            if (response.data.message) {
              errorMsg = response.data.message;
            }
            this.$message.error(errorMsg);
          }
        } catch (error) {
          let errorMsg = '授权失败';
          if (error.response) {
            if (error.response.data && error.response.data.error) {
              errorMsg = error.response.data.error;
            } else if (error.response.statusText) {
              errorMsg = error.response.statusText;
            }
          } else if (error.message) {
            errorMsg = error.message;
          }
          this.$message.error(errorMsg);
          console.error('授权错误:', error);
        } finally {
          this.confirmLoading = false;
        }
      }).catch(() => {
        // 用户取消确认
      });
    },

    // 获取账号列表
    async fetchAccountList() {
      this.loading = true;
      try {
        const params = {
          action: this.searchForm.ghz_name ? 'search' : 'list',
          store_id: this.userInfo.id,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        };

        if (this.searchForm.ghz_name) {
          params.ghz_name = this.searchForm.ghz_name;
        }

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/gzh_auth_management.php`,
          params
        );

        if (data.data) {
          this.accountList = data.data;
          this.pagination.total = data.pagination?.total || data.data.length;
        }
      } catch (error) {
        this.$message.error('获取账号列表失败');
        console.error('获取账号列表错误:', error);
      } finally {
        this.loading = false;
      }
    },

    // 处理搜索
    handleSearch() {
      this.pagination.page = 1;
      this.fetchAccountList();
    },

    // 获取授权信息
    async fetchLicenseInfo() {
      try {
        const response = await axios.post(
          `${config.BASE_URL}/shop/api/gzh_auth_management.php`,
          {
            action: 'license_info',
            store_id: this.userInfo.id
          }
        );

        if (response.data && !response.data.error) {
          this.licenseInfo = {
            total: response.data.total || 0,
            used: response.data.used || 0,
            remaining: response.data.remaining || 0
          };
        }
      } catch (error) {
        console.error('获取授权信息失败:', error);
      }
    },

    // 打开新增对话框
    async openAddDialog() {
      // 首先检查 smart_card_zt 状态
      if (!this.hasSmartCardZt) {
        // 单主体模式，检查是否已有账号
        const existingAccounts = this.accountList.filter(item => item.store_id === this.userInfo.id);
        if (existingAccounts.length >= 1) {
          this.$message.warning('单主体模式下只能添加1个账号，请删除现有账号后再添加新账号！');
          return;
        }
      } else {
        // 多主体模式，检查授权数量
        if (this.licenseInfo.total !== -1 && this.licenseInfo.remaining <= 0) {
          this.$message.warning('授权账号数已满，请联系管理员充值！');
          return;
        }
      }

      this.dialogTitle = '新增TX广告';
      this.isEditMode = false;
      this.accountForm = {
        id: null,
        ghz_name: '',
        ip_port: '',
        ip_password: '',
        ghz_appid: '',
        ghz_secret: '',
        notes: ''
      };
      this.dialogVisible = true;
    },

    // 打开编辑对话框
    openEditDialog(row) {
      this.dialogTitle = '编辑TX广告';
      this.isEditMode = true;
      this.accountForm = {
        id: row.id,
        ghz_name: row.ghz_name,
        ip_port: row.ip_port,
        ip_password: row.ip_password,
        ghz_appid: row.ghz_appid,
        ghz_secret: row.ghz_secret,
        notes: row.notes
      };
      this.dialogVisible = true;
    },

    // 提交表单（新增/编辑）
    submitAccountForm() {
      this.$refs.accountForm.validate(async (valid) => {
        if (valid) {
          try {
            if (!this.isEditMode) {
              // 新增时的前置检查
              if (!this.hasSmartCardZt) {
                // 单主体模式检查
                const existingAccounts = this.accountList.filter(item => item.store_id === this.userInfo.id);
                if (existingAccounts.length >= 1) {
                  this.$message.warning('单主体模式下只能添加1个账号！');
                  return;
                }
              } else {
                // 多主体模式检查
                const canAddResponse = await axios.post(
                  `${config.BASE_URL}/shop/api/gzh_auth_management.php`,
                  {
                    action: 'can_add',
                    store_id: this.userInfo.id
                  }
                );

                if (canAddResponse.data.error) {
                  if (canAddResponse.data.code === 'QUOTA_EXCEEDED') {
                    this.$message.warning('授权账号数已满，请联系管理员充值！');
                    return;
                  }
                  this.$message.error(canAddResponse.data.error || '操作失败');
                  return;
                }

                if (!canAddResponse.data.can_add) {
                  this.$message.warning('授权账号数已满，请联系管理员充值！');
                  return;
                }
              }
            }

            const action = this.isEditMode ? 'update' : 'add';
            const payload = {
              ...this.accountForm,
              store_id: this.userInfo.id,
              auth_method: 1 // 固定为密钥授权
            };

            const response = await axios.post(
              `${config.BASE_URL}/shop/api/gzh_auth_management.php`,
              {
                action,
                ...payload
              }
            );

            if (response.data.error) {
              if (response.data.reason && response.data.code) {
                this.$message.error(`${response.data.error}: ${response.data.reason} (错误代码: ${response.data.code})`);
              } else {
                this.$message.error(response.data.error || '操作失败');
              }
            } else if (response.data.success) {
              this.$message.success(this.isEditMode ? '更新成功' : '添加成功');
              this.dialogVisible = false;
              this.fetchAccountList();
            } else {
              this.$message.error('操作失败，未知错误');
            }
          } catch (error) {
            let errorMsg = '操作失败';

            if (error.response && error.response.data) {
              const errorData = error.response.data;

              if (errorData.error && errorData.reason && errorData.code) {
                errorMsg = `${errorData.error}: ${errorData.reason} (错误代码: ${errorData.code})`;
              } else if (errorData.error) {
                errorMsg = errorData.error;
              } else if (errorData.message) {
                errorMsg = errorData.message;
              }
            } else if (error.message) {
              errorMsg = error.message;
            }

            this.$message.error(`操作失败: ${errorMsg}`);
            console.error('表单提交错误:', error);
          }
        }
      });
    },

    // 删除账号
    async handleDelete(id) {
      this.$confirm('确定要删除该TX广告账号吗？', '警告', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await axios.post(
            `${config.BASE_URL}/shop/api/gzh_auth_management.php`,
            {
              action: 'delete',
              id: id,
              store_id: this.userInfo.id
            }
          );

          if (response.data.error) {
            if (response.data.reason && response.data.code) {
              this.$message.error(`${response.data.error}: ${response.data.reason} (错误代码: ${response.data.code})`);
            } else {
              this.$message.error(response.data.error || '删除失败');
            }
          } else if (response.data.success) {
            this.$message.success('删除成功');
            this.fetchAccountList();
          } else {
            this.$message.error('删除失败，未知错误');
          }
        } catch (error) {
          let errorMsg = '删除失败';

          if (error.response && error.response.data) {
            const errorData = error.response.data;

            if (errorData.error && errorData.reason && errorData.code) {
              errorMsg = `${errorData.error}: ${errorData.reason} (错误代码: ${errorData.code})`;
            } else if (errorData.error) {
              errorMsg = errorData.error;
            } else if (errorData.message) {
              errorMsg = errorData.message;
            }
          } else if (error.message) {
            errorMsg = error.message;
          }

          this.$message.error(`删除失败: ${errorMsg}`);
          console.error('删除错误:', error);
        }
      }).catch(() => { });
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  padding: 20px;
}

/* 头部区域样式 */
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.license-info {
  display: flex;
  gap: 20px;
  background: #f0f7ff;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
}

.license-item {
  display: flex;
  align-items: center;

  .label {
    color: #606266;
    font-weight: 500;
  }

  .value {
    font-weight: 600;
    color: #409eff;
  }
}

.settings-form {
  max-width: 95%;
  margin: 0 auto;
  padding: 32px 40px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.page-title {
  font-size: 24px;
  color: #1f2937;
  margin-bottom: 32px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.5px;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
}

.pagination-container {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

/* 表格样式优化 */
.el-table {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;

  :deep(.el-table__header) th {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
  }

  :deep(.el-table__body) tr:hover>td {
    background-color: #f0f7ff !important;
  }
}

/* 操作按钮样式 */
.el-button {
  display: inline-flex;
  align-items: center;

  .el-icon {
    margin-right: 5px;
  }
}

/* 对话框样式优化 */
:deep(.el-dialog) {
  border-radius: 12px;

  .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid #ebeef5;
    margin-right: 0;

    .el-dialog__title {
      font-weight: 600;
      color: #1f2937;
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #ebeef5;
  }
}

/* 密码预览样式 */
.password-preview {
  font-family: monospace;
  background-color: #f5f7fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 13px;
}

/* 表单提示样式 */
.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 6px;
}

/* 空值样式 */
.empty-value {
  color: #909399;
  font-style: italic;
}

/* 表单验证提示样式 */
:deep(.el-form-item__error) {
  font-size: 12px;
  padding-top: 4px;
}

.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;

    span {
      margin-top: 10px;
    }
  }

  .qr-code-image {
    width: 200px;
    height: 200px;
    margin-bottom: 20px;
    border: 1px solid #eee;
  }

  .qr-instructions {
    margin-top: 15px;
    text-align: center;
    color: #606266;
    font-size: 14px;

    p {
      margin: 5px 0;
    }
  }
}

/* RPA授权按钮组样式 */
.rpa-auth-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.fingerprint-status {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
}

.success-icon,
.error-icon {
  cursor: pointer;
}

/* 悬停提示框样式 */
:deep(.fingerprint-tooltip) {
  max-width: 400px !important;
}

.fingerprint-detail {
  padding: 10px;
}

.fingerprint-detail h4 {
  margin: 0 0 12px 0;
  color: #409EFF;
  font-size: 14px;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 8px;
}

.fingerprint-item {
  display: flex;
  margin-bottom: 8px;
  line-height: 1.4;
}

.fingerprint-label {
  font-weight: 600;
  color: #606266;
  min-width: 120px;
  margin-right: 10px;
}

.fingerprint-value {
  color: #909399;
  word-break: break-all;
  flex: 1;
}

/* 在线授权对话框样式 */
.online-auth-dialog-wrapper {
  :deep(.el-dialog__header) {
    background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
    margin: 0;

    .el-dialog__title {
      color: white;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__headerbtn {
      .el-dialog__close {
        color: white;
        font-size: 18px;
      }
    }
  }

  :deep(.el-dialog__body) {
    padding: 30px;
  }
}

.online-auth-dialog {
  .section-title {
    color: #1f2937;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    &::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 16px;
      background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
      border-radius: 2px;
      margin-right: 8px;
    }
  }
}

/* 授权方式选择 */
.auth-type-buttons {
  :deep(.el-radio-group) {
    width: 100%;
    display: flex;
    gap: 16px;
  }

  :deep(.el-radio) {
    flex: 1;
    margin: 0;
    height: auto;

    .el-radio__label {
      padding: 0;
      width: 100%;
    }
  }
}

.auth-type-item {
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  padding: 24px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: transparent;
    transition: all 0.3s ease;
  }

  &:hover {
    border-color: #409EFF;
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.15);

    &::before {
      background: #409EFF;
    }
  }
}

:deep(.el-radio.is-checked) {
  .auth-type-item {
    border-color: #409EFF;
    background: linear-gradient(135deg, #f0f7ff 0%, #ecf5ff 100%);

    &::before {
      background: #409EFF;
    }

    .selected-indicator {
      opacity: 1;
      transform: scale(1);
    }
  }
}

.wechat-item:deep(.el-radio.is-checked) {
  .auth-type-item {
    border-color: #07C160;
    background: linear-gradient(135deg, #f0f9f4 0%, #ecf8f1 100%);

    &::before {
      background: #07C160;
    }
  }
}

.auth-icon-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 16px;
}

.auth-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  transition: all 0.3s ease;
}

.wechat-icon {
  background: linear-gradient(135deg, #07C160 0%, #06AD56 100%);
  color: white;
}

.qq-icon {
  background: linear-gradient(135deg, #12B7F5 0%, #0EA5E0 100%);
  color: white;
}

.selected-indicator {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 20px;
  height: 20px;
  background: #07C160;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transform: scale(0);
  transition: all 0.3s ease;

  .el-icon {
    color: white;
    font-size: 12px;
  }
}

.auth-text {
  text-align: left;
}

.auth-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 6px;
}

.auth-desc {
  font-size: 13px;
  color: #666;
  margin-bottom: 12px;
  line-height: 1.4;
}

.auth-features {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.feature-tag {
  background: rgba(64, 158, 255, 0.1);
  color: #409EFF;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
}

.wechat-item .feature-tag {
  background: rgba(7, 193, 96, 0.1);
  color: #07C160;
}

/* 授权流程 */
.auth-process-section {
  margin: 30px 0;
  padding: 25px;
  background: #f8fafc;
  border-radius: 12px;
}

.process-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.process-step {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
}

.step-number {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.step-content {
  flex: 1;
}

.step-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
}

.step-desc {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

.step-arrow {
  color: #909399;
  font-size: 18px;
  font-weight: 300;
  flex-shrink: 0;
}

/* 温馨提示 */
.tips-section {
  background: linear-gradient(135deg, #fffbf0 0%, #fef6e6 100%);
  border: 1px solid #ffe58f;
  border-radius: 8px;
  padding: 20px;
}

.tips-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;

  .tips-icon {
    color: #faad14;
    font-size: 16px;
  }

  span {
    color: #1f2937;
    font-weight: 600;
    font-size: 14px;
  }
}

.tips-content {
  p {
    margin: 6px 0;
    color: #666;
    font-size: 13px;
    line-height: 1.5;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

/* 对话框底部 */
.dialog-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;

  .cancel-btn {
    padding: 12px 24px;
    border: 1px solid #dcdfe6;

    &:hover {
      border-color: #409EFF;
      color: #409EFF;
    }
  }

  .confirm-btn {
    padding: 12px 32px;
    background: linear-gradient(135deg, #07C160 0%, #06AD56 100%);
    border: none;

    &:hover {
      background: linear-gradient(135deg, #06AD56 0%, #059A4C 100%);
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(7, 193, 96, 0.3);
    }

    .el-icon {
      margin-right: 6px;
    }
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .online-auth-dialog-wrapper {
    :deep(.el-dialog) {
      width: 95% !important;
      margin: 20px auto;
    }
  }

  .auth-type-buttons :deep(.el-radio-group) {
    flex-direction: column;
  }

  .process-steps {
    flex-direction: column;
    gap: 20px;
  }

  .step-arrow {
    transform: rotate(90deg);
  }
}

/* 新增账号高亮样式 */
:deep(.el-table .newly-authorized) {
  background-color: #f0f9ff !important;
  animation: highlightFade 3s ease-in-out;
}

:deep(.el-table .newly-authorized:hover) {
  background-color: #e6f7ff !important;
}

@keyframes highlightFade {
  0% {
    background-color: #bae7ff;
  }

  50% {
    background-color: #91d5ff;
  }

  100% {
    background-color: #f0f9ff;
  }
}

/* 更新账号高亮样式 */
:deep(.el-table .updated-account) {
  background-color: #f6ffed !important;
  animation: updateHighlight 3s ease-in-out;
}

@keyframes updateHighlight {
  0% {
    background-color: #d9f7be;
  }

  50% {
    background-color: #b7eb8f;
  }

  100% {
    background-color: #f6ffed;
  }
}
</style>